import { useState } from "react";
import { faqs } from "@/mocks/faqs";

export default function FaqSection() {
  const [openId, setOpenId] = useState<number | null>(1);

  return (
    <section className="w-full border-t border-background-200 bg-background-100">
      <div className="mx-auto grid w-full max-w-[1280px] grid-cols-1 gap-10 px-4 py-14 md:px-8 md:py-20 lg:grid-cols-[0.8fr_1.2fr] lg:gap-16">
        <div>
          <p className="text-xs tracking-[0.24em] text-secondary-600">FAQ</p>
          <h2 className="mt-3 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
            常见问题
          </h2>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600">
            关于素材来源、反差指数口径和内容更新方式，这里有比较直接的回答。没找到答案可以到联系页面留言。
          </p>
          <i className="ri-question-answer-line mt-6 hidden text-6xl text-background-300 lg:block"></i>
        </div>

        <div className="flex flex-col divide-y divide-background-200 border-y border-background-200">
          {faqs.map((faq) => {
            const open = openId === faq.id;
            return (
              <div key={faq.id}>
                <h3>
                  <button
                    type="button"
                    aria-expanded={open}
                    onClick={() => setOpenId(open ? null : faq.id)}
                    className="flex w-full cursor-pointer items-center justify-between gap-4 py-5 text-left"
                  >
                    <span className="font-heading text-base font-bold text-foreground-950">
                      {faq.q}
                    </span>
                    <span
                      className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full border transition-colors ${
                        open
                          ? "border-primary-500 bg-primary-500 text-background-50"
                          : "border-background-300 text-foreground-600"
                      }`}
                    >
                      <i className={open ? "ri-subtract-line" : "ri-add-line"}></i>
                    </span>
                  </button>
                </h3>
                {open && (
                  <p className="pb-6 pr-10 text-sm leading-relaxed text-foreground-600">{faq.a}</p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}